import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DeviceService } from '../../../services/device.service';
import { Button } from '../../../../shared/components/ui/buttons/gradient-btn/button';
import { MatDialogRef } from '@angular/material/dialog';
import { SettingsVideo } from '../../../../features/settings';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCameraMovie } from '@fortawesome/pro-duotone-svg-icons';
import { OdinService } from '../../../services/odin.service';

@Component({
  selector: 'andor-camera-preview',
  imports: [FontAwesomeModule, TranslatePipe, Button, SettingsVideo],
  templateUrl: './camera-preview.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './camera-preview.scss',
})
export class CameraPreview {
  protected readonly faCameraMovie = faCameraMovie;

  constructor(
    public dialogRef: MatDialogRef<CameraPreview>,
    public deviceService: DeviceService,
    public odinService: OdinService
  ) {}

  async startCam() {
    try {
      await this.odinService.startCam();
    } catch (e) {
      console.error(e);
      // Keep the dialog open — the embedded settings-video preview shows
      // the camera error and offers a retry.
      return;
    }
    this.dialogRef.close(false);
  }
}
